import './NotFoundPage.css'

const NotFoundPage = () => {
  return (
    <div className="notFoundPage">
      <h1>Oops, that page doesn't exist.</h1>
      <img src="https://zwsmith-portfolio.s3.us-west-2.amazonaws.com/404-Bigfoot.webp" alt="404 Bigfoot"/>
    </div>
  )
}

export default NotFoundPage
